export default __webpack_public_path__ + "static/logo-ihr-a522e7526f63159a8a4c86d8b15babed.png";